// 画面レイアウト
import header from '@/components/organisms/TheHeader'
import footer from '@/components/organisms/TheFooter'
import sidebar from '@/components/organisms/TheSidebar'

// ------------------------------------------------------------
// システム画面
// ------------------------------------------------------------
// import PageMaintainance from '@/components/page/PageMaintainance'
import PageUnauthorized from '@/components/pages/static/PageUnauthorized'
import PageNotFound from '@/components/pages/static/PageNotFound'
import PageUnlicensed from '@/components/pages/static/PageUnlicensed'

// ------------------------------------------------------------
// 管理画面 isAdminPage: true
// ------------------------------------------------------------
export default [
  // // Network Error
  // {
  //   path: '/page-maintainance',
  //   name: 'page-maintainance',
  //   meta: {
  //     needAuth: false
  //   },
  //   components: {
  //     header,
  //     sidebar,
  //     footer,
  //     content: PageMaintainance
  //   }
  // },
  {
    path: '/page-unlicensed',
    name: 'page-unlicensed',
    meta: {
      needAuth: false
    },
    components: {
      header,
      sidebar,
      footer,
      content: PageUnlicensed
    }
  },
  // 401
  {
    path: '/page-unauthorized',
    name: 'page-unauthorized',
    meta: {
      needAuth: false
    },
    components: {
      header,
      sidebar,
      footer,
      content: PageUnauthorized
    }
  },
  // 404
  {
    path: '*',
    meta: {
      needAuth: false
    },
    components: {
      header,
      sidebar,
      footer,
      content: PageNotFound
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.system.js